import { useState } from 'react';
import { Button } from '../components/primitives';
import useTimedError from '../hooks/useTimedError';
import analyticsSoon from '../assets/analytics-soon.png';
import { useAuthGet } from '../hooks/useAxios';
import { useAuth } from '../contexts/AuthContext';
import { useOutletContext } from 'react-router-dom';

export default function Analytics() {
    const { clientData } = useOutletContext();
    return (
        <div className="analytics-container">
            <h3>Analytics Coming Soon</h3>
            <img src={analyticsSoon} alt="Analytics Coming Soon" className="analytics-soon-image" />
            <SupabaseToCSV CSVName="Contacts" workspaces={clientData?.workspaces} />
        </div>
    );
}

const SupabaseToCSV = ({ CSVName, workspaces }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useTimedError();
    const { get } = useAuthGet();
    const { url } = useAuth();

    const downloadCSV = async () => {
        setIsLoading(true);
        try {
            const response = await get(url + "/supabase/contacts");
            const contacts = response.data;

            if (!contacts || contacts.length === 0) {
                setError('No contacts. Check workspace settings to collect contacts.');
                setIsLoading(false);
                return;
            }

            // Enhance contacts with workspace and channel names from clientData
            const enhancedContacts = contacts.map(contact => {
                const enhancedContact = {...contact};
                
                // Add workspace name if available
                if (contact.workspace && workspaces?.[contact.workspace]) {
                    enhancedContact.workspaceName = workspaces[contact.workspace].workspaceName || 
                                                   workspaces[contact.workspace].name || 
                                                   contact.workspace;
                }
                
                // Add channel name if available
                if (contact.channel && 
                    contact.workspace && 
                    workspaces?.[contact.workspace]?.channels?.[contact.channel]
                ) {
                    enhancedContact.channelName = workspaces[contact.workspace].channels[contact.channel].name || 
                                                 contact.channel;
                }
                
                return enhancedContact;
            });

            // Get all unique keys from all contacts
            const allKeys = new Set();
            enhancedContacts.forEach(contact => {
                Object.keys(contact).forEach(key => allKeys.add(key));
            });

            // Create CSV header
            const headers = Array.from(allKeys);

            // Create CSV data
            const csvData = [
                headers.join(','),
                ...enhancedContacts.map(contact => 
                    headers.map(header => {
                        const value = contact[header] || '';
                        return typeof value === 'string' && value.includes(',') 
                            ? `"${value}"`
                            : value;
                    }).join(',')
                )
            ].join('\n');

            // Create and trigger download
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', `${CSVName}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            setIsLoading(false);
        } catch (err) {
            console.error('Error fetching contact data:', err);
            setError('Error fetching contact data');
            setIsLoading(false);
        }
    };

    return (
        <div className="analytics-select-workspace-container">
            <Button
                onClick={downloadCSV}
                disabled={isLoading}
                className="submit settings analytics-download-csv-button"
                loading={isLoading}
                error={error}
            >
                {error ? error : 'Download Contact CSV'}
            </Button>
        </div>
    );
};

